import { cn } from "@/lib/utils"

interface MaxWidthContainerProps {
    children?: React.ReactNode;
    className?: string;
}

const MaxWidthContainer = ({ children = null, className = "" }: MaxWidthContainerProps) => {
    return (
        <div className={cn("h-full w-full px-5 md:px-8 lg:px-10 xl:px-20 min-[1400px]:px-24 max-w-[99rem] mx-auto", className)}>
            {children}
        </div>
    )
}

export default MaxWidthContainer